import { Outlet, useOutletContext } from 'react-router'
import { useRedirectQaPhotoset } from '@/features/photoset/hooks/use-redirect-qa-photoset'
import { useGetPhotoset } from '@/features/photoset/queries/use-get-photoset'
import type { PhotosetURLParams } from '@/features/photoset/types'

export const PhotosetQaRoute = () => {
	const outletContext = useOutletContext<{ urlParams: PhotosetURLParams }>()
	const { data: photoset } = useGetPhotoset(
		{ id: outletContext.urlParams.id },
		{ staleTime: Number.POSITIVE_INFINITY }
	)

	// Redirect the user to the current QA Step
	useRedirectQaPhotoset({
		photosetId: photoset?.id,
		qaStepId: photoset?.qa_step_id
	})

	return <Outlet context={outletContext} />
}
